module.exports = __webpack_public_path__ + "img/avatar-s-7.b00fd0f7.jpg";